<!--DISCOUNT SLIDER-->
<section class="center-slider-wrp-2 center-slider-offer" *ngIf="responseReceived && banners.length > 0">
  <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1"
       uk-slider="center: true; autoplay: true; autoplay-interval: 6000; pause-on-hover: false;">

    <ul class="uk-slider-items uk-grid-small" uk-grid>

      <li class="uk-width-3-4" *ngFor="let banner of banners">

        <div class="uk-panel">
          <a href="{{banner.banner_url}}">
            <picture>
              <source media="(max-width:767px)" srcset="{{banner.banner_file_mobile}}">
              <source media="(min-width:768px)" srcset="{{banner.banner_file_desktop}}">
              <img data-src="{{banner.banner_file_desktop}}" alt="" class="img-full border-radius-banner" uk-img>
            </picture>
          </a>
        </div>
      </li>

    </ul>

    <a class="uk-position-center-left uk-position-small hideMobile" href="#" uk-slidenav-previous
       uk-slider-item="previous"></a>
    <a class="uk-position-center-right uk-position-small hideMobile" href="#" uk-slidenav-next
       uk-slider-item="next"></a>

  </div>
</section>

<!--LOADER-->
<section class="center-slider-wrp-2 center-slider-offer">
  <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1"
       uk-slider="center: true; autoplay: true; autoplay-interval: 6000; pause-on-hover: false;"
       *ngIf="!responseReceived">
    <ul class="uk-slider-items uk-grid-small" uk-grid>
      <li class="uk-width-3-4" *ngFor="let banner of [1,2,3]">
        <!--LOADER-->
        <ngx-skeleton-loader animation="progress" appearance="line">
        </ngx-skeleton-loader>
      </li>
    </ul>
  </div>
</section>
